/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    BedroomParentOutlined, ChildCare,
    NightsStayOutlined, PersonAdd, PersonOutline,
    PointOfSaleOutlined,
    PriceChangeOutlined,
    SellOutlined
} from "@mui/icons-material";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Reserva_Descuento from "./Formulario_Reserva_Descuento";
import {Tarjeta_Descuento} from "../../Tarjetas/Tarjeta_Descuento";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {TIPOCLIENTE} from "../../../Constantes";
import {useEffect, useState} from "react";
import {obtenerValorSaldo} from "../../../CodNegocio/obtenerValorSaldo";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";

const Formulario_Reserva_Descuentos = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        dato: 'descuentos',
        nombre: 'Descuentos',
        Formulario: Formulario_Reserva_Descuento,
        Tarjeta: Tarjeta_Descuento,
    })
    const [valorSaldo, setValorSaldo] = useState(false)


    useEffect(() => {

        if (props.props) {
            let valores = props.props.getValues()
            setValorSaldo(obtenerValorSaldo({
                totalReserva: valores.valor,
                adicionales: valores.adicionales,
                descuentos: valores.descuentos,
                abonos: valores.abonos,
            }))
        }

    }, [props.props])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                    <Typography sx={{fontSize: 18, fontWeight: 800}}>
                        {`Saldo: ${formatoMoneda(valorSaldo)}`}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={SellOutlined} nombre={'Tipo de cliente'} dato={'tipoCliente'}
                                   opciones={TIPOCLIENTE} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BedroomParentOutlined} nombre={'# Habitacion'} dato={'numero'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={NightsStayOutlined} nombre={'Num Noches'} dato={'numNoches'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PersonOutline} nombre={'num Adultos'} dato={'numAcompanantes'}
                                  editable={false} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={PriceChangeOutlined} nombre={'Valor Adultos'} dato={'valorAdultos'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={ChildCare} nombre={'Num Niños'} dato={'numNinos'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={PriceChangeOutlined} nombre={'Valor Niños'} dato={'valorNinos'} {...props}
                                   editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoDinero Icono={PointOfSaleOutlined} nombre={'Valor Habitacion'} dato={'valor'} {...props}
                                   editable={false}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresarObjeto/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Notas Internas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Notas Internas'} dato={'notas'} {...props}
                                  lineas={6}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Descuentos